module.exports = __webpack_public_path__ + "assets/54514eeb17cf05261fbe91b5007e1703.mp3";